import { render } from "./workers.vue?vue&type=template&id=1011b8f8"
import script from "./workers.vue?vue&type=script&lang=js"
export * from "./workers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__